__webpack_require__.p = "/Mini-Projects-Collection-React/";